import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView } from '../services/api/pageview.api';

/**
 * 페이지 조회수 자동 추적 훅
 *
 * 사용법:
 * 1. App.tsx 또는 최상위 레이아웃에서 한 번 호출
 * 2. 페이지 이동 시 자동으로 조회수 기록
 *
 * @example
 * function App() {
 *   usePageView();
 *   return <Routes>...</Routes>;
 * }
 */
export function usePageView() {
  const location = useLocation();
  const lastTrackedPath = useRef<string | null>(null);

  useEffect(() => {
    // 같은 페이지 중복 기록 방지
    if (lastTrackedPath.current === location.pathname) {
      return;
    }

    lastTrackedPath.current = location.pathname;

    // 조회수 기록 (비동기, 실패해도 무시)
    recordPageView(location.pathname);
  }, [location.pathname]);
}

export default usePageView;
